import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Text } from '@adc/ui-core'
import { CONTRACTING_NOTIFICATION_TEXT } from '../../constants'

const cx = classnames.bind({})

const ContractMessage = ({ notification }) => {
  const { cta, message } = notification
  const elmId = 'contract_notification'

  return cta ? (
    <Text data-elm-id={elmId}>
      {message}{' '}
      <a
        className={cx('u-pointer-cursor')}
        data-elm-id={`${elmId}_cta`}
        href={cta.href}
      >
        {cta.text}
      </a>
    </Text>
  ) : null
}

ContractMessage.propTypes = {
  notification: PropTypes.shape({
    cta: PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    }),
    message: PropTypes.string,
  }),
}

const ContractColor = { color: 'info' }

const ContractNotification = notification => {
  const modifiedNotification = {
    ...notification,
    message: CONTRACTING_NOTIFICATION_TEXT,
  }

  return {
    message: <ContractMessage notification={modifiedNotification} />,
    ...ContractColor,
  }
}

export default ContractNotification
